export default __webpack_public_path__ + "static/media/ObjectScanner.256.e5c7bb8e.png";